import { graphql } from "react-relay";

export const UpdateAPIKeyMutation = graphql`
  mutation UpdateAPIKeyMutation($input: UpdateAPIKeyInput!) {
    updateAPIKey(input: $input) {
      key {
        description
        id
        identity
      }
      problems {
        message
      }
    }
  }
`;
